// Cloudinary configuration
const cloudinaryConfig = {
  cloudName: 'konzo-vibez', // Replace with your Cloudinary cloud name
  apiKey: '338882221913494', // Replace with your Cloudinary API key
  apiSecret: '5TeeEuWhAtfyVjXdlDY_sTyhb5s', // Replace with your Cloudinary API secret
  uploadPreset: 'konzo_marketplace', // Replace with your upload preset (if using unsigned uploads)
  folder: 'konzo_products'
};

export default cloudinaryConfig;
